import { ComponentConstants, Events, eventsManager, Functionality, Room } from '@rhinov/savane-js';
import { FiltersWidget } from '../FiltersWidget';
import { FilterGroup } from '../Tools/FilterGroup';
import { FiltersController } from '../Tools/FiltersController';
import { PlanManager } from '@rhinov/cocos-plan';

export class BudgetsFilterWidget extends FilterGroup {

    roomsChildrenCount: any = {};
    roomsWatcher: number | undefined;
    cachedSelectedEntities: any[] = [];
    selectedEntitiesWatcher: number | undefined;

    constructor(container: string) {
        super();
        this.id = 'budgets';
        this.name = 'Budget meubles par pièce';
        this.resource = 'assets';
        this.icon = 'fas fa-lg fa-euro-sign';
        this.container = container;
        this.controller = new FiltersController();
    }

    static getInstance(): BudgetsFilterWidget | null {
        if (!FiltersWidget.filterGroups || FiltersWidget.filterGroups.length === 0) return null;
        return FiltersWidget.filterGroups.find((filterGroup: FilterGroup) => filterGroup.id === 'budgets') as BudgetsFilterWidget || null;
    }

    update(): void {
        this.destroy();
        this.html();
    }

    updateTitles(): void {
        $('.row-title').each((_index, element) => {
            const id = element.id.split('-').at(-3) ?? '';
            $(element).prop('style', FilterGroup.isBudgetObjectSelected(id));
        });
    }

    html(): void {
        this.isDestroyed = false;

        FilterGroup.getAllObjectPricesAndSupply().then(() => {
            setTimeout(() => {
                $('#inputMDMOnly').prop('checked', FilterGroup.seeOnlyMDMObjects);
                this.cachedSelectedEntities = PlanManager.getInstance().selectedEntities;
                FilterGroup.addEntitySelectionListener(this.updateTitles);

                this.controller.addEventListener('change', () => {
                    FilterGroup.seeOnlyMDMObjects = $('#inputMDMOnly').prop('checked');
                    FilterGroup.resetRoomBudget();
                    this.update();
                }, 'inputMDMOnly')

                this.controller.addEventListener('change', () => {
                    let instance = PlanManager.getInstance();
                    if (instance) {
                        // Try override with rhinov format is already added
                        if (instance.world) {
                            instance.world._customTargetDate = $('#inputForecastDate').prop('value');
                        }
                    }

                    FilterGroup.resetRoomBudget();
                    this.update();
                }, 'inputForecastDate')

                this.controller.addEventListener('click', () => {
                    let instance = PlanManager.getInstance();
                    if (instance) {
                        if (instance.world) {
                            if (instance.world._customTargetDate) {
                                instance.world._customTargetDate = null;
                            }
                        }
                    }

                    FilterGroup.resetRoomBudget();
                    this.update();
                }, 'reinitDateBtn')
            });

            let html = this.filtersHtml() + `
            <div>
                <span style="padding-right:48px">MDM seulement <input id="inputMDMOnly" type="checkbox"/></span>
                <span>Date prévisionnelle<input id="inputForecastDate" type="date" value="` + FilterGroup.getSupplyForcastedDate() + `"/></span>
                <span><button class="btn-default" id="reinitDateBtn" title="Réinitialiser date prévisionnelle"><span style="margin-left: 8px;">Réinit</span></button></span>

                <div class="table-responsive">
                    <table class="table table-striped" style="table-layout: fixed">
                        ${this.getBudgetsTableHeaderHtml()}
                        ${this.getBudgetsBodyHtml()}
                        ${this.getGlobalBudgetsBodyHtml()}
                    </table>
                </div>
            </div>
            `;
            let container = document.getElementById(this.container);
            if (!container) {
                return;
            }
            container.innerHTML = html;
            eventsManager.instance.dispatch(Events.CAMERA_RESIZED);
        });
    }

    getBudgetsTableHeaderHtml(): string {
        return `
        <thead>
            <tr>
                <th style="text-align: center;width:200px">Pièces/Objets</th>
                <th style="text-align: center;width:100px">Nb exemp.</th>
                <th style="text-align: center;width:100px">Dispo auj.</th>
                <th style="text-align: center;width:100px">Dispo prév.</th>
                <th style="text-align: center;width:50px">Total</th>
            </tr>
        </thead>
        `;
    }

    rooms(): any[] {
        var instance = PlanManager.getInstance();
        if (!instance) {
            return [];
        }

        var result: any[] = [];
        for (var i = 0; i < instance.world.floors.length; ++i) {
            result = result.concat(instance.world.floors[i].rooms);
        }

        return result;
    };

    getBudgetsBodyHtml(): string {
        const rooms = Object.values(
            Object.groupBy(
                this.rooms(),
                room => room
                    .getComponent(ComponentConstants.ComponentType.Functionality)
                    .functionalityName
            )
        ).filter((roomGroup): roomGroup is NonNullable<typeof roomGroup> => roomGroup !== undefined);

        rooms.forEach(roomGroup => {
            const room = roomGroup[0];

            const name = room
                .getComponent(ComponentConstants.ComponentType.Functionality)
                .functionalityName;

            this.roomsChildrenCount[name] = roomGroup.reduce(
                (count, room) => count + room.children.length,
                0
            );
        });

        this.roomsWatcher = setInterval(() => {
            const newRooms = Object.values(
                Object.groupBy(
                    this.rooms(),
                    room => room
                        .getComponent(ComponentConstants.ComponentType.Functionality)
                        .functionalityName
                )
            );

            const changed = newRooms.some(roomGroup => {
                if (!roomGroup) {
                    return false;
                }

                const room = roomGroup[0];

                const name = room
                    .getComponent(ComponentConstants.ComponentType.Functionality)
                    .functionalityName;

                const newCount = roomGroup.reduce(
                    (count, room) => count + room.children.length,
                    0
                );

                return this.roomsChildrenCount[name] !== newCount;
            });

            if (changed) {
                clearInterval(this.roomsWatcher);
                this.roomsWatcher = undefined;
                this.update();
            }
        }, 100);

        return rooms.map((roomGroup, idx) => {
            let budget = 0;
            roomGroup.map((room) => {
                budget += Number(FilterGroup.getRoomBudget(room));
            })

            const objectsHtml = roomGroup
                .map(room => this.getObjectsHtml(room, idx))
                .join('');

            setTimeout(() => {
                this.controller.addEventListener('click', () => {
                    roomGroup.forEach(room => {
                        FilterGroup.toggleRoomCollapsed(room);
                    });

                    this.update();
                }, `room-title-${idx}`);
            });

            return `
                <tbody>
                    <tr>
                        <td>
                            <span style="float: left;font-weight: bold;" id="room-title-${idx}">
                                ${FilterGroup.getRoomName(roomGroup[0])}
                            </span>
                        </td>
                        <td></td>
                        <td></td>
                        <td></td>
                        <td>
                            <span style="float: left;font-weight: bold;">
                                ${budget}€
                            </span>
                        </td>
                    </tr>
                    ${objectsHtml}
                </tbody>
            `;
        }).join('');
    }

    getObjectsHtml(room: any, idx: number): string {
        let objects = FilterGroup.getRoomDetails(room);
        return objects.map((object, obj_idx) => {
            setTimeout(() => {
                this.controller.addEventListener('click', () => {
                    FilterGroup.clickBudgetObject(object);
                    this.update();
                }, `room-${idx}-objects-${obj_idx}-td`);
            });

            return `
                <tr ${FilterGroup.isRoomCollapsed(room) ? 'style="display:none"' : ''}>
                    <td id="room-${idx}-objects-${obj_idx}-td">
                        <span style="float: left;">
                            <img src="${FilterGroup.getRoomObjectThumbnailUrl(object)}" height="40px">
                        </span>
                        <span id="room-${idx}-objects-${object.objectId}-${obj_idx}-title" class="row-title" style="${FilterGroup.isBudgetObjectSelected(object.objectId)}">${object.name}</span>
                    </td>
                    <td style="text-align: center;">
                        <span>${object.quantity}</span>
                    </td>
                    <td style="text-align: center;">
                        <span>${object.availability}</span>
                    </td>
                    <td style="text-align: center;">
                        <span>${object.availabilitySoon}</span>
                    </td>
                    <td>
                        <span style="float: left;">${object.total.toFixed(2)}€</span>
                    </td>
                </tr>
                `;
        }).join('');
    }

    getGlobalBudgetsBodyHtml(): string {
        let oobBudget = FilterGroup.getRoomBudget(null);
        let objectsHtml = this.getObjectsHtml(null, 0);

        setTimeout(() => {
            this.controller.addEventListener('click', () => {
                FilterGroup.toggleRoomCollapsed(null);
                this.update();
            }, "room-name");
        });
        return `
        <tbody>
            <tr>
                <td>
                    <span id="room-name" style="float: left;font-weight: bold;">${FilterGroup.getRoomName(null)}</span>
                </td>
                <td>
                </td>
                <td>
                </td>
                <td>
                </td>
                <td>
                    <span style="float: left;font-weight: bold;">${oobBudget}€</span>
                </td>
            </tr>
            ${objectsHtml}
            <tr>
                <td>
                    <span style="float: left;font-weight: bold;">Total</span>
                </td>
                <td>
                </td>
                <td>
                </td>
                <td>
                </td>
                <td>
                    <span style="float: left;font-weight: bold;">${FilterGroup.getTotalBudget()}€</span>
                </td>
            </tr>
        </tbody>
        `;
    }

    destroy(): void {
        super.destroy();
        clearInterval(this.roomsWatcher);
        FilterGroup.removeEntitySelectionListener(this.updateTitles);
    }
}